import * as React from 'react';
import { useTheme } from '@material-ui/core';
function CheckCircleIcon(props) {
  var size = props.size === 'xlarge' ? 64 : 24;
  var theme = useTheme();
  var color = props.color ? theme.palette[props.color].main : 'currentColor';
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    fill: color
  }));
}
export default CheckCircleIcon;